// extracted by mini-css-extract-plugin
export default {"content":"IconTooltip_content__hqF5I","tooltip":"IconTooltip_tooltip__CnFn5"};